export default __webpack_public_path__ + "static/meaningImg-883b317a14ca1081ff6a5f80fbf0c54b.png";